import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

import i18n from 'portal-base/src/decorators/i18n';

import { KiDsPwaComponent } from '../../base/ki-ds-pwa-component';
import nls from '../../locales/indexes.nls';
import style from './ki-ds-pwa-footer.css';

const CLASS_NAME = 'ki-ds-pwa-footer';

@i18n(nls)
@customElement(CLASS_NAME)
class KiDsPwaFooter extends KiDsPwaComponent {
    static styles = style;

    render() {
        return html`
            <div class="footer">
                <div class="footer__timezone">
                    ${this._getLabel('all_timestamps_in_timezone')}:
                    ${Intl.DateTimeFormat().resolvedOptions().timeZone}
                </div>
            </div>
        `;
    }
}
